import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import AuthCallback from './pages/AuthCallback';
import { useSession } from './store/session';
import { installContextGlobal } from './lib/context';

// Initialize session and context globally on package/module load to handle refreshes on any sub-route safely
useSession.getState().init().catch(console.error);
installContextGlobal();

// Studio is a heavy bundle (ffmpeg, three.js timeline, etc.) — load only when visited.
const StudioPage = lazy(() => import('./studio/StudioPage'));
const CodeEditorPage = lazy(() => import('./components/CodeEditorPage'));

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/studio" element={
          <Suspense fallback={<div style={{ padding: 24, fontSize: 12 }} className="sc">loading studio…</div>}>
            <StudioPage />
          </Suspense>
        } />
        <Route path="/code/*" element={
          <Suspense fallback={<div style={{ padding: 24, fontSize: 12 }} className="sc">loading editor…</div>}>
            <CodeEditorPage />
          </Suspense>
        } />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
